import {
    addNewPi,
    getProcessingInstruction,
    makePiDom,
} from '../../utility/xmlHelpers';
import { xmlToString } from '../../xmlUtility';

// 2023-11-01 - Code moved from loader.js

function setPiAttributes(pi, values) {
    var piDom = makePiDom(pi);

    Object.keys(values).forEach(function (key) {
        piDom.setAttribute(key, values[key]);
    });

    pi.nodeValue = Array.from(piDom.attributes).map(xmlToString).join(' ');
}

export function ensureProcessingInstruction(
    node,
    piName,
    values,
    addIfMissing,
) {
    let pi = getProcessingInstruction(node, piName);

    if (!pi) {
        if (addIfMissing) {
            pi = addNewPi(node, piName);
        } else {
            return;
        }
    }

    setPiAttributes(pi, values);
}

export function getPiAttribute(ownerNode, piName, attributeName) {
    const pi = getProcessingInstruction(ownerNode, piName);
    const piDom = pi && makePiDom(pi);

    return piDom && piDom.getAttribute(attributeName);
}
